// extracted by mini-css-extract-plugin
export default {"fill":"AsideElementFill_fill__gBgwS"};